<template>
  <BootstrapModal class="EditProductGroup"
    v-on="$listeners"

    @save="saveProductGroup"
  >
    <FormInput
      class="form-element"
      v-model="$v.name.$model"

      id="supplier"
      label="Leverancier"

      :vuelidate="$v"
      fieldName="name"
    />

    <template #title>
      {{ supplier ? "Leverancier bewerken" : "Leverancier toevoegen" }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import FormInput from "src/components/Inputs/FormInput.vue"

import { required } from "vuelidate/lib/validators"

export default {
  props: ["supplier", "callback"],
  components: {
    BootstrapModal,
    FormInput,
  },
  validations: {
    name: {
      required,
    },
  },
  data() {
    return {
      name: "",
    }
  },
  created() {
    if (this.supplier) {
      console.log(this.supplier)
      this.$v.name.$model = this.supplier.name
    }
  },
  methods: {
    saveProductGroup() {
      this.$v.$touch()
      if (this.$v.$error) return;

      const payload = {
        name: this.$v.name.$model,
      }

      this.$handlePromise(async () => {
        if (this.supplier) {
          await this.axios.put(`/api/suppliers/${this.supplier.uid}`, payload)
        } else {
          await this.axios.post(`/api/suppliers`, payload)
        }
        this.$store.dispatch('clearCacheSearch', "suppliers")

        this.$success("Leverancier succesvol opgeslagen!")
        this.callback && this.callback()
        this.$emit("close")
      })
    },
  },
}

</script>

<style scoped>

.EditProductGroup {
  flex-basis: 500px;
}

</style>
